import React from "react";
import { Outlet } from "react-router-dom";
import TemplateAccess from "./TemplateAccess";
import TemplateManage from "./TemplateManage";

const TemplatePage = () => (
  <div className="layout-content px-3 sm:px-5 md:px-5">
    <Outlet />
  </div>
);

export { TemplatePage, TemplateAccess, TemplateManage };
